export interface TeamMember {
  name: string;
  position: string;
  imageUrl: string;
  description: string;
  email?: string;
  variant: 'support' | 'founder' | 'admin';
}

export const teamData: TeamMember[] = [
  {
    name: 'Michael Carter',
    position: 'Content editor',
    imageUrl: '/images/team/MichaelCarter.jpg',
    description: `Hello, I'm Michael Carter. For me, words matter, especially when it comes to your money. As a content editor at RTPCheck, I'm the person who makes sure that every offer on this site is crystal clear, honest and fact-based. I don't tolerate ambiguity and empty promises that the gambling world is full of. that you only get verified information about the return percentage (RTP) and the real operation of the casino. If the text has passed my check, then it can be trusted. No compromises.`,
    variant: 'support',
    email: 'michael.carter@rtpcheck.com',
  },
  {
    name: 'Sarah Mitchell',
    position: 'Blog content manager',
    imageUrl: '/images/team/SarahMitchell.jpg',
    description: `Hi, my name is Sarah Mitchell and I am a Blog content manager. I believe that knowledge is power, especially in the world of online casinos. I don't just write articles; I create guides that help you feel more confident. My goal is to become your expert friend who will always explain complex things, such as what RTP is, in simple language. I want you to read my materials not only to learn something new, but to feel that you care about your safety and make an informed choice. Let's make gambling more understandable and honest together!`,
    variant: 'support',
    email: 'sarah.mitchell@rtpcheck.com',
  },
  {
    name: 'James Stewards',
    position: 'Blog content manager',
    imageUrl: '/images/team/JamesStewards.jpg',
    description: `I'm James Stewards, and for me, slots are not just a job. I've been in this game for more than ten years, since the days when everything was easier. I've experienced firsthand how the industry has changed, and not always for the better. I remember that unpleasant feeling when you lose your favorite slot over and over again and realize that the casino could quietly "tweak" the returns. It was this injustice that made me turn my passion into a mission. As a Blog content manager, I dig into the mechanics of slots and analyze the RTP so that you, unlike me in the past, always know where to play fair.`,
    variant: 'support',
    email: 'james.stewards@rtpcheck.com',
  },
  {
    name: 'Emily Rogers',
    position: 'News content manager',
    imageUrl: '/images/team/EmilyRogers.jpg',
    description: `My name is Emily Rogers and I'm a News content manager at RTPCheck. My job is to be your eyes and ears in the industry. I'm always on the lookout for news about casinos that suddenly change the rules or start delaying payouts or a flurry of complaints - I immediately sound the alarm in our news section. My job is to warn you of danger before you encounter it.`,
    variant: 'support',
    email: 'emily.rogers@rtpcheck.com',
  },
  {
    name: 'David Thompson',
    position: 'News content manager',
    imageUrl: '/images/team/DavidThompson.jpg',
    description: `Hi, I'm David Thompson, and I'm also a News content manager. While Emily follows breaking news, I look at the big picture. I'm an analyst who connects the dots on the map of the gambling industry. Why did this provider suddenly reduce the RTP in all its games? What does the new law mean for players from your country? to show you not only what's going on, but why. My goal is to help you understand trends and make strategic decisions about where to play.`,
    variant: 'support',
    email: 'david.thompson@rtpcheck.com',
  },
  {
    name: 'Alex Johnson',
    position: 'RTP inspector',
    imageUrl: '/images/team/AlexJohnson.jpg',
    description: `My name is Alex Johnson. I'm an RTP inspector. I don't believe in words, I believe in numbers. My job is cold, unbiased data analysis. Every day I run thousands and thousands of spins on different slots and in different casinos, collecting statistics. For me, there are no "good" or "bad" casinos - there are only mathematical facts. I am the one who provides irrefutable evidence so that you can be sure of the fairness of the game.`,
    variant: 'support',
    email: 'alex.johnson@rtpcheck.com',
  },
  {
    name: 'Laura Bennett',
    position: 'RTP inspector',
    imageUrl: '/images/team/LauraBennett.jpg',
    description: `Hello, I'm Laura Bennett and I'm an RTP inspector. My fight for justice is not just a job, it's very personal. A few years ago, a close friend of mine faced blatant dishonesty: an online casino blocked his account for no reason after winning big. I investigate player complaints. I'm here to turn your sense of injustice into real action and protect our community.`,
    variant: 'support',
    email: 'laura.bennett@rtpcheck.com',
  },
];
